import {
  FaBell,
  FaCogs,
  FaLock,
  FaShieldAlt,
  FaTools,
  FaVideo,
} from "react-icons/fa";

const Services = () => {
  const services = [
    {
      icon: <FaShieldAlt className="text-blue-600 text-4xl" />,
      title: "Security Consultancy",
      description:
        "Expert guidance to identify vulnerabilities and develop modern security strategies.",
    },
    {
      icon: <FaLock className="text-blue-600 text-4xl" />,
      title: "Access Control Technologies",
      description:
        "Advanced access control solutions including biometrics, smart cards, and keyless entry systems.",
    },
    {
      icon: <FaVideo className="text-blue-600 text-4xl" />,
      title: "CCTV Cameras",
      description:
        "High-quality surveillance solutions for real-time monitoring and security enforcement.",
    },
    {
      icon: <FaBell className="text-blue-600 text-4xl" />,
      title: "Intrusion Detection Alarms",
      description:
        "Reliable alarm systems to detect and alert security breaches instantly.",
    },
    {
      icon: <FaTools className="text-blue-600 text-4xl" />,
      title: "Security Gadgets",
      description:
        "Innovative security gadgets including GPS tracking, motion detectors, and panic buttons.",
    },
    {
      icon: <FaCogs className="text-blue-600 text-4xl" />,
      title: "System Integration",
      description:
        "Seamless integration of security technologies with existing systems for enhanced efficiency.",
    },
  ];

  return (
    <section
      className="bg-gray-100 text-gray-900 py-20 px-6 md:px-12"
      id="services"
    >
      <div className="max-w-7xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold">Our Services</h2>
        <p className="mt-4 text-lg text-gray-700 max-w-3xl mx-auto">
          NOBLE SECURE TECHNOLOGIES offers a comprehensive range of cutting-edge
          security services designed to keep you safe and secure.
        </p>
        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white px-6 py-12 rounded-lg shadow-lg flex flex-col items-center text-center gap-2"
            >
              {service.icon}
              <h3 className="text-3xl font-semibold mt-4 px-3">{service.title}</h3>
              <p className="mt-2 text-gray-600">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
